var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14ZM11.7486 10.2298L7.26627 8.01517C7.22792 7.9962 7.19136 7.98725 7.15833 7.98725C7.11127 7.98725 7.07148 8.00553 7.04347 8.03891C7.01607 8.07155 7 8.11873 7 8.17777V17.6852C7 17.847 7.11983 18.0386 7.26627 18.1109L11.4085 20.1575C11.466 20.186 11.5208 20.1995 11.5704 20.1995C11.71 20.1995 11.8079 20.0927 11.8079 19.9136V10.3246C11.8079 10.2845 11.7849 10.2477 11.7486 10.2298ZM21.0237 20.1545L16.9986 18.1658L21.4231 11.0612V19.9105C21.4231 20.1532 21.2434 20.263 21.0237 20.1545ZM12.2327 10.9415V15.814L16.6157 17.9795L12.2327 10.9415ZM16.7489 7.94947L21.3178 10.2069C21.3747 10.235 21.395 10.3052 21.3616 10.3588L16.8653 17.5789L13.7217 12.531L16.5378 8.00895C16.5677 7.96093 16.623 7.93335 16.6786 7.93335C16.6794 7.93335 16.6801 7.93348 16.6809 7.9336C16.6816 7.93371 16.6823 7.93382 16.683 7.93384C16.7056 7.93443 16.7282 7.9392 16.7489 7.94947Z",
    fill: "#005BBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.df25732f4cc06e8efbbdd9fb0cb21381.svg";
export { ForwardRef as ReactComponent };